import { IElement, FetchModulesResult } from './type';

// const heavyControlUuids = ['associated_view', 'work_item_view', 'work_item_view_v2', 'schedule_table'];
const heavyControlUuids = [ 'schedule_table'];

type GetHeavyComConfigInfoParams = {
  defaultNodeKey?: string;
  defaultTabKey?: string;
  data?: FetchModulesResult;
};

export function getHeavyComConfigInfo(props: GetHeavyComConfigInfoParams) {
  const { defaultNodeKey, defaultTabKey, data } = props;
  if (!data) {
    return {};
  }

  const workItem = (data?.biz_data)?.find(item => item.key === 'workitem');

  const nodeModule = data?.modules?.[0]?.children?.find((child) => child.key === 'detail:workflow');

  const flowMode = nodeModule ? 'workflow' : 'stateflow';

  const workflowNodeModule = nodeModule?.children?.find((child) => child.key === 'detail:workflow:node');

  const nodeFormModule = getModule(nodeModule, 'detail:workflow:node:form');

  let nodeKey = defaultNodeKey;
  let nodeFormControls: IElement[] = [];
  if (nodeFormModule) {
    nodeKey = nodeFormModule.uuid;
    nodeFormControls = findHeavyControls(nodeFormModule);
  }

  const subWorkItemData = data?.biz_data?.filter((item) => item.key === 'sub_work_item');
  const heavyControlConfInfo = getSubTaskAndSubWorkItemConfInfo(
    workflowNodeModule,
    nodeKey,
    subWorkItemData,
    flowMode,
    workItem?.value?.template_version,
  );

  const tabModules = getModule(data.modules, 'detail:tabs');

  const selectedTab =
    tabModules?.children?.find((item) => (item?.props?.key || '') === defaultTabKey) ??
    tabModules?.children?.[0];

  const selectTabModule = selectedTab?.children?.filter((child) => child.key === 'form:root')?.[0];

  const formControls = findHeavyControls(selectTabModule);

  const controlsElements = formControls.concat(nodeFormControls);
  controlsElements?.forEach((element) => {
    const controlType = element?.props?.schema?.key;

    if (!heavyControlConfInfo.hasOwnProperty(controlType)) {
      heavyControlConfInfo[controlType] = [];
    }

    if (controlType !== 'schedule_table') {
      heavyControlConfInfo[controlType].push({
        uuid: element.uuid,
        view_id: element?.props?.schema?.params?.uuid,
        flowMode,
      });
    } else {
      heavyControlConfInfo[controlType].push({
        uuid: element.uuid,
        filter_condition: element?.props?.schema?.filter_condition,
        flowMode,
      });
    }
  });

  return heavyControlConfInfo;
}

const getSubTaskAndSubWorkItemConfInfo = (
  workflowNodeModule?: IElement,
  nodeKey?: string,
  subWorkItemData?: Record<string, unknown>[],
  flowMode?: string,
  templateVersion?: string,
) => {
  if (!workflowNodeModule || !nodeKey) {
    return {};
  }
  const subTaskModule = workflowNodeModule?.children?.find(
    (child) => child.key === 'detail:workflow:node:task',
  );

  // const subWorkItemModule = workflowNodeModule?.children?.find(
  //   (child) => child.key === 'detail:workflow:node:sub_workitems',
  // );
  const subWorkItemModule = false;

  const confInfo: Record<string, any> = {};
  if (subTaskModule) {
    confInfo.sub_task = [{ node_key: subTaskModule.uuid, flowMode }];
  }
  if (subWorkItemModule) {
    confInfo.sub_work_items = subWorkItemModule.children?.map((child) => {
      const viewControlConf = subWorkItemData?.find((item) => item?.uuid === child?.uuid)?.value?.data
        ?.view_control_conf;
      if (viewControlConf) {
        return {
          node_key: subWorkItemModule.uuid,
          view_id: viewControlConf.view_uuid,
          version: viewControlConf.version,
          flowMode,
          template_version: templateVersion,
        };
      }
      return null;
    });
  }
  return confInfo;
};

const findHeavyControls = (selected: IElement) => {
  const result: IElement[] = [];
  const traverse = (node: IElement) => {
    if (
      node?.key === 'form:field' &&
      node?.props?.schema?.key &&
      heavyControlUuids?.includes(node?.props?.schema?.key)
    ) {
      result.push(node);
    }
    if (node?.children) {
      node?.children?.forEach((child) => traverse(child));
    }
  };
  traverse(selected);
  return result;
};

function getModule(data: any, targetKey: string): any {
  if (Array.isArray(data)) {
    for (const item of data) {
      const result = getModule(item, targetKey);
      if (result) {
        return result;
      }
    }
  } else if (typeof data === 'object' && data !== null) {
    if (data.key === targetKey) {
      return data;
    }
    if (data.children) {
      return getModule(data.children, targetKey);
    }
  }
  return null;
}
